<template>
	<div class="container">
		<div class="content">
			<el-form :model="formInfo" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="公司名称" prop="companyName">
					<el-input clearable placeholder="请输入单位名称" v-model="formInfo.companyName"></el-input>
				</el-form-item>
				<el-form-item label="营业执照" prop="businessLicense">
					<el-upload :action=uploadUrl list-type="picture-card" accept=".jpg,.jpeg,.png,.gif" :limit="1"
						:before-upload="beforeUpload" :on-success="handleSuccessBusiness" :on-preview="handlePreview"
						:on-remove="handleRemoveBusiness">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>
				<el-form-item label="联系人姓名" prop="contactPerson">
					<el-input clearable placeholder="请输入联系人姓名" v-model="formInfo.contactPerson"></el-input>
				</el-form-item>
				<el-form-item label="联系人电话" prop="contactPhone">
					<el-input clearable placeholder="请输入联系人电话" v-model="formInfo.contactPhone"></el-input>
				</el-form-item>
				<el-form-item label="登录账号" prop="userName">
					<el-input clearable placeholder="手机号、邮箱、公司名称（英文或拼音）" v-model="formInfo.userName"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input clearable type="password" placeholder="密码要包含数字、大写字母、小写字母和特殊符号，且不少于6位数"
						v-model="formInfo.password"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmpwd">
					<el-input clearable type="password" placeholder="请确认登录密码" v-model="formInfo.confirmpwd"></el-input>
				</el-form-item>
			</el-form>
			<div class="button-single">
				<span @click="submitInfo">提 交</span>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	export default {
		name: 'ActivitySubmit',
		components: {

		},
		data() {
			//自定义验证规则
			//验证营业执照图片上传
			let validateImage = (rule, value, callback) => { // 验证器
				if (!this.checkImgSuccess) { // 为true代表图片在  false报错
					callback(new Error('请上传营业执照！'))
				} else {
					callback()
				}
			};
			let validatePassword = (rule, value, callback) => {
				if (value.length < 6) {
					callback(new Error('密码长度不少于6位'));
				} else if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/\d/.test(value) || !/[^a-zA-Z0-9]/.test(
						value)) {
					callback(new Error('密码必须包含数字、大写字母、小写字母和特殊符号'));
				} else {
					callback();
				}
			};
			let checkPhone = (rule, value, callback) => { // 手机号验证
				if (!value) {
					return callback(new Error('请输入联系人电话'));
				} else {
					const reg = /^1[3456789]\d{9}$/
					if (reg.test(value)) {
						callback();
					} else {
						return callback(new Error('请输入正确的手机号'));
					}
				}
			};
			let validatePass2 = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.formInfo.password) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};
			return {
				uploadUrl: '', //图片上传地址
				checkImgSuccess: false,
				dialogImageUrl: '',
				dialogVisible: false,
				formInfo: {
					companyName: '', //单位名称
					userName: '', //登录账号
					contactPerson: '', //联系人姓名
					contactPhone: '', //联系电话
					businessLicense: '', //营业执照
					password: '',
					confirmpwd: ''
				},
				rules: {
					companyName: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}],
					contactPerson: [{
						required: true,
						message: '请输入联系人姓名',
						trigger: 'blur'
					}],
					contactPhone: [{
						required: true,
						validator: checkPhone,
						trigger: 'blur'
					}],
					userName: [{
						required: true,
						message: '请输入登录账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: validatePassword,
						trigger: 'blur'
					}],
					confirmpwd: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}],
					businessLicense: [{
						required: true,
						validator: validateImage,
						trigger: 'change'
					}],
				}
			}
		},
		created() {
			this.uploadUrl = config.baseUrl + 'admin/sys/upload'
		},
		methods: {
			//上传营业执照
			beforeUpload(file) {
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['jpg', 'jpeg', 'png', 'gif']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("只能上传jpg,jpeg,png,gif格式图片！")
					return false
				}
			},
			handleSuccessBusiness(res) {
				let entity = res.entity
				this.formInfo.businessLicense = entity.fileUrl
				this.$refs.ruleForm.clearValidate() // 上传成功清除校验
				this.checkImgSuccess = true
			},
			handlePreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleRemoveBusiness(file) {
				console.log(file)
				this.formInfo.businessLicense = ''
				this.checkImgSuccess = false // 检查图片是否加载成功
				this.$refs.ruleForm.validate() // 删除图片,重新触发校验
			},
			//提交信息
			async submitInfo() {
				this.$refs.ruleForm.validate(async valid => {
					if (valid) {
						//提交入驻
						let param = this.formInfo
						ajaxParam(param)
						const res = await post('admin/index/companySettled', qs.stringify(param))
						if (res.data.code == 200) {
							this.$message.success('您的入驻信息已提交成功，平台3个工作日内会完成审核！')
							// this.formInfo.companyName = ''
							// this.formInfo.userName = ''
							// this.formInfo.contactPerson = ''
							// this.formInfo.contactPhone = ''
							// this.formInfo.businessLicense = ''
							// this.formInfo.password = ''
							// this.formInfo.confirmpwd = ''
							// this.dialogImageUrl = ''
							setTimeout(res=>{
								window.location.reload()
							},3000)
							
						} else {
							this.$message.error(res.data.msg)
						}
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	// /deep/ .el-form-item:last-of-type{
	// 	display: flex;
	// 	flex-direction: column;
	// 	.el-form-item__label{
	// 		text-align: left;
	// 	}
	// }
	.content {
		width: 760px;
		margin-left: auto;
		margin-right: auto;

		.title {
			padding: 10px 0 20px;
		}
	}

	/deep/ .el-upload-list--picture-card .el-upload-list__item,
	/deep/ .el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 80px;
	}
</style>